import * as React from 'react';

interface SettingsSubTitleProps {
    title: string;
}

export const SettingsSubTitle: React.FunctionComponent<SettingsSubTitleProps> = ({ title }) => (
    <h3
        style={{
            color: 'var(--r-grey-3)',
            fontSize: '18px',
            lineHeight: '34px',
            margin: '10px 28px 0 28px',
        }}
    >
        {title}
    </h3>
);
